<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="13.5" viewBox="0 0 13.5 13.5">
    <g id="ic-layout-square-grid" transform="translate(0.917 0.917)">
      <rect
        id="Rectangle_79"
        data-name="Rectangle 79"
        width="12"
        height="12"
        rx="2"
        transform="translate(-0.167 -0.167)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
      <line
        id="Line_287"
        data-name="Line 287"
        y1="11"
        transform="translate(4.833 -0.167)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1" />
    </g>
  </svg>
</template>
